"use client";

import { c as _c } from "react/compiler-runtime";
import { publicEnv } from "@/config/env";
import { Consolidation } from "@/entities/IDelegation";
import { areEqualAddresses } from "@/helpers/Helpers";
import { fetchAllPages } from "@/services/6529api";
import { faFileUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import styles from "./MappingTool.module.scss";
const csvParser = require("csv-parser");
interface ConsolidationData {
  address: string;
  token_id: number;
  balance: number;
  contract: string;
  name: string;
}
export default function ConsolidationMappingTool() {
  const $ = _c(44);
  const inputRef = useRef(null);
  const [dragActive, setDragActive] = useState(false);
  const [file, setFile] = useState();
  const [processing, setProcessing] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [consolidations, setConsolidations] = useState(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [csvData, setCsvData] = useState(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = function submit() {
      setProcessing(true);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const submit = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      (inputRef.current as any).click();
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleUpload = t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (e.type === "dragenter" || e.type === "dragover") {
        setDragActive(true);
      } else {
        if (e.type === "dragleave") {
          setDragActive(false);
        }
      }
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const handleDrag = t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = function (e_0) {
      e_0.preventDefault();
      e_0.stopPropagation();
      setDragActive(false);
      if (e_0.dataTransfer.files && e_0.dataTransfer.files[0]) {
        setFile(e_0.dataTransfer.files[0]);
      }
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const handleDrop = t5;
  let t6;
  if ($[6] !== consolidations) {
    t6 = function getForAddress(address) {
      const myConsolidations = consolidations.find(c => c.wallets.some(w => areEqualAddresses(address, w)));
      return myConsolidations;
    };
    $[6] = consolidations;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const getForAddress = t6;
  let t7;
  if ($[8] !== csvData) {
    t7 = function sumForAddresses(addresses, token_id, contract) {
      const myConsolidations_0 = csvData.filter(d => addresses.some(a => areEqualAddresses(a, d.address)) && areEqualAddresses(contract, d.contract) && token_id === d.token_id);
      const balance = myConsolidations_0.reduce(_temp, 0);
      return balance;
    };
    $[8] = csvData;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const sumForAddresses = t7;
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = function downloadCsvFile(data) {
      const csvData_0 = data.map(_temp2);
      const csvString = `${"address,token_id,balance,contract,name"}\n${csvData_0.join("\n")}`;
      const blob = new Blob([csvString], {
        type: "text/csv;charset=utf-8;"
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", "consolidation_output.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const downloadCsvFile = t8;
  let t9;
  if ($[11] !== file || $[12] !== processing) {
    t9 = () => {
      const fetchConsolidations = async function fetchConsolidations(url_0) {
        fetchAllPages(url_0).then(consolidations_0 => {
          setConsolidations(consolidations_0);
          const reader = new FileReader();
          reader.onload = async () => {
            const data_0 = reader.result;
            const results = [];
            let isFirstRow = true;
            const parser = csvParser({
              headers: true
            }).on("data", row => {
              if (isFirstRow) {
                isFirstRow = false;
              } else {
                const address_0 = row._0;
                const token_id_0 = Number.parseInt(row._1, 10);
                const balance_0 = Number.parseInt(row._2, 10);
                const contract_0 = row._3;
                const name = row._4;
                results.push({
                  address: address_0,
                  token_id: token_id_0,
                  balance: balance_0,
                  contract: contract_0,
                  name
                });
              }
            }).on("end", () => {
              setCsvData(results);
            }).on("error", _temp3);
            parser.write(data_0);
            parser.end();
          };
          reader.readAsText(file);
        });
      };
      if (processing) {
        const initialUrl = `${publicEnv.API_ENDPOINT}/api/consolidations`;
        fetchConsolidations(initialUrl);
      }
    };
    $[11] = file;
    $[12] = processing;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== processing) {
    t10 = [processing];
    $[14] = processing;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  useEffect(t9, t10);
  let t11;
  if ($[16] !== consolidations || $[17] !== csvData || $[18] !== getForAddress || $[19] !== sumForAddresses) {
    t11 = () => {
      const out = [];
      if (csvData.length > 0 && consolidations.length > 0) {
        csvData.map(consolidationData => {
          const addressConsolidations = getForAddress(consolidationData.address);
          if (addressConsolidations) {
            const sum = sumForAddresses(addressConsolidations.wallets, consolidationData.token_id, consolidationData.contract);
            if (areEqualAddresses(consolidationData.address, addressConsolidations.primary) || sum === consolidationData.balance) {
              out.push({
                ...consolidationData,
                address: addressConsolidations.primary,
                balance: sum
              });
            }
          } else {
            out.push(consolidationData);
          }
        });
        downloadCsvFile(out);
        setProcessing(false);
      }
    };
    $[16] = consolidations;
    $[17] = csvData;
    $[18] = getForAddress;
    $[19] = sumForAddresses;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== csvData) {
    t12 = [csvData];
    $[21] = csvData;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  useEffect(t11, t12);
  let t13;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Row><Col>Upload File <span className="font-color-h">(.csv)</span></Col></Row>;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  const t14 = `${styles.uploadArea} ${dragActive ? styles.uploadAreaActive : ""}`;
  let t15;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div><FontAwesomeIcon icon={faFileUpload} className={styles.uploadIcon} /></div>;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== file) {
    t16 = file ? <div>{file.name}</div> : <div>Drag and drop your file here, or click to upload</div>;
    $[25] = file;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t14 || $[28] !== t16) {
    t17 = <Row className="pt-2"><Col><Container className={t14} onClick={handleUpload} onDrop={handleDrop} onDragEnter={handleDrag} onDragLeave={handleDrag} onDragOver={handleDrag}>{t15}{t16}</Container></Col></Row>;
    $[27] = t14;
    $[28] = t16;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  const t18 = `${styles.submitBtn} ${processing || !file ? styles.submitBtnDisabled : ""}`;
  let t19;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = () => submit();
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  const t20 = processing ? "Processing" : "Submit";
  let t21;
  if ($[31] !== processing) {
    t21 = processing && <div className="d-inline"><div className={`spinner-border ${styles.loader}`} role="status"><span className="sr-only" /></div></div>;
    $[31] = processing;
    $[32] = t21;
  } else {
    t21 = $[32];
  }
  let t22;
  if ($[33] !== t18 || $[34] !== t20 || $[35] !== t21) {
    t22 = <Row className="pt-3"><Col><Button className={t18} onClick={t19}>{t20}{t21}</Button></Col></Row>;
    $[33] = t18;
    $[34] = t20;
    $[35] = t21;
    $[36] = t22;
  } else {
    t22 = $[36];
  }
  const t23 = file?.fileName;
  let t24;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = e_1 => {
      if (e_1.target.files) {
        const f = e_1.target.files[0];
        setFile(f);
      }
    };
    $[37] = t24;
  } else {
    t24 = $[37];
  }
  let t25;
  if ($[38] !== t23) {
    t25 = <Form.Control ref={inputRef} className={`${styles.formInputHidden}`} type="file" accept=".csv" value={t23} onChange={t24} />;
    $[38] = t23;
    $[39] = t25;
  } else {
    t25 = $[39];
  }
  let t26;
  if ($[40] !== t17 || $[41] !== t22 || $[42] !== t25) {
    t26 = <Container className={styles.toolArea} id="mapping-tool-form">{t13}{t17}{t22}{t25}</Container>;
    $[40] = t17;
    $[41] = t22;
    $[42] = t25;
    $[43] = t26;
  } else {
    t26 = $[43];
  }
  return t26;
}
function _temp3(err) {
  console.error(err);
}
function _temp2(d_0) {
  return `${d_0.address},${d_0.token_id},${d_0.balance},${d_0.contract},${d_0.name}`;
}
function _temp(a_0, b) {
  return a_0 + b.balance;
}